import { render, staticRenderFns } from "./EventTypeEdit.vue?vue&type=template&id=6d366f1d&scoped=true"
import script from "./EventTypeEdit.vue?vue&type=script&lang=js"
export * from "./EventTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./EventTypeEdit.vue?vue&type=style&index=0&id=6d366f1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d366f1d",
  null
  
)

export default component.exports